import { validateRequiredFields } from '@/Framework/UI/Organisms/FinalForm/validators/validateRequiredFields';
import { validateRecaptchaVerified } from '@/Framework/UI/Organisms/FinalForm/validators/validateRecaptchaVerified';
import { validateCompanyName } from '@/Framework/UI/Organisms/FinalForm/validators/company/validateCompanyName';
import { validateName } from '@/Framework/UI/Organisms/FinalForm/validators/user/validateName';
import { validateNumber } from '@/Framework/UI/Organisms/FinalForm/validators/validateNumber';
import { validateEmail } from '@/Framework/UI/Organisms/FinalForm/validators/user/validateEmail';
import { validatePhoneNumber } from '@/Framework/UI/Organisms/FinalForm/validators/user/validatePhoneNumber';
import {
  groupValidators,
} from '@/Framework/UI/Organisms/FinalForm/validators/helpers';

export default (values) => groupValidators(
  validateRequiredFields([
    { fieldName: 'activeDatarooms', fieldCaption: '#' },
    { fieldName: 'currentDataroomProvider', fieldCaption: 'Provider' },
    { fieldName: 'company', fieldCaption: 'Company' },
    { fieldName: 'firstName', fieldCaption: 'First Name' },
    { fieldName: 'lastName', fieldCaption: 'Last Name' },
    { fieldName: 'email', fieldCaption: 'Corporate email' },
  ], values),
  validateRecaptchaVerified({ fieldName: 'recaptcha', value: values.recaptcha }),
  validateCompanyName({ fieldName: 'company', fieldCaption: 'Company', value: values.company }),
  validateName({ fieldName: 'firstName', fieldCaption: 'First Name', value: values.firstName }),
  validateName({ fieldName: 'lastName', fieldCaption: 'Last Name', value: values.lastName }),
  validateNumber({ fieldName: 'activeDatarooms', fieldCaption: '#', value: values.activeDatarooms }),
  validateEmail({ fieldName: 'email', value: values.email }),
  validatePhoneNumber({
    fieldName: 'phone',
    fieldCaption: 'Phone Number',
    value: values.phone,
    isRequired: true,
  }),
);
